module.exports = __webpack_public_path__ + "static/media/logo.dcae98bd.png";